import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledModal,
    StyledH2,
    StyledButton,
    StyledLabel,
} from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";

import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

export function ConfirmationTimeZone({
    setSelectedValue,
    isModalOpened,
    setIsModalOpened,
    value,
    handleTimezoneChange,
}: any) {
    const { t } = useTranslation();
    const handleConfirm = () => {
        handleTimezoneChange(value); // ✅ reset pause + apply new timezone
        setIsModalOpened(false);
    };

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalOpened(!isModalOpened);
                }}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-4">
                    {t(
                        "Attention: If you change the time zone, the “order interruption“ setting will be reset."
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    rounded
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                    }}
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <StyledButton rounded variant="primary" onClick={handleConfirm}>
                    {t("Validate")}
                </StyledButton>
            </ModalFooter>
        </StyledModal>
    );
}
